module.exports = __webpack_public_path__ + "static/clemson-restaurant-on-lake-hartwell-4934980e76dd6ecd433c2c23914066de.jpg";